import { useTranslation } from 'react-i18next';
import { formatPrice } from '../utils/priceFormat';

type TPriceDisplay = (value: number | string) => string;

const usePriceDisplay = (
  currency: string
): { getPriceDisplay: TPriceDisplay } => {
  const { i18n } = useTranslation();
  const getPriceDisplay: TPriceDisplay = (value) =>
    formatPrice(value, currency, i18n.resolvedLanguage);
  return { getPriceDisplay };
};

export default usePriceDisplay;
